import script from "./CUdcList.vue?vue&type=script&setup=true&lang=js"
export * from "./CUdcList.vue?vue&type=script&setup=true&lang=js"

import "./CUdcList.vue?vue&type=style&index=0&id=1244fbf5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1244fbf5"]])

export default __exports__